import { createAsyncThunk } from '@reduxjs/toolkit';

import CLIENT from '../../utils/CLIENT';
import { Customer, UpdateCustomerPayload } from './types';

export const updateCustomer = createAsyncThunk<Customer, UpdateCustomerPayload>(
  'customers/updateCustomer',
  async ({ id, ...body }) => {
    const response = await CLIENT({
      url: `/customers/${encodeURIComponent(id)}`,
      method: 'PATCH',
      body,
    });

    return response.data as Customer;
  },
);
